export default __webpack_public_path__ + "static/media/Organizational.f7f74eff.png";